export default __webpack_public_path__ + "static/media/cardDue.619522bb.svg";